import { render, staticRenderFns } from "./PrivacyAgreementModal.vue?vue&type=template&id=16c0b93c&scoped=true"
import script from "./PrivacyAgreementModal.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreementModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAgreementModal.vue?vue&type=style&index=0&id=16c0b93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0b93c",
  null
  
)

export default component.exports